import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import UpsellCarousel from '~/shared/components/UpsellCarousel';
import featureNames from '~/shared/constants/featureFlags';
import { ProductTag } from '~/shared/constants/products';
import { getDefaultProductFilters } from '~/shared/utils/getDefaultProductFilters';
import useHasFeature from '~/shared/utils/useHasFeature';
import { getMembership } from '~/techstyle-shared/react-accounts';
import {
  mobile,
  useProductDetailSelectionState,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';
import { useProductListing } from '~/techstyle-shared/react-products';
// import { getDefaultProductFilters } from '~/shared/utils/products';

const CarouselWrapper = styled.div`
  ${mobile`
    padding: 16px;
  `};
`;

const Heading = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 25px;
  color: ${({ theme }) => theme.colors.sublabelBlack};

  ${mobile`
    font-size: 16px;
  `}
`;

function OOSCarousel({ fplIds }) {
  const removeOriginFlag = useHasFeature(featureNames.REMOVE_ORIGIN);
  const baseParams = {
    backgroundFplIds: fplIds,
    size: 15,
    includeOutOfStock: true,
  };
  if (removeOriginFlag) {
    baseParams.excludeTagIds = [ProductTag.removeOrigin];
  }
  const params = useSelector((state) =>
    getDefaultProductFilters(getMembership(state), state.domain.tld, baseParams)
  );
  const { products = [] } = useProductListing(params, { apiVersion: 2 });
  const isPlusSizeSelected =
    useProductDetailSelectionState()?.isPlusSizeSelected ?? false;

  if (!products.length) {
    return null;
  }

  return (
    <CarouselWrapper>
      <Heading>
        <FormattedMessage
          id="site_pdp.oos_heading"
          defaultMessage="Sorry, this product is no longer available. Check out these similar products: "
        />
      </Heading>
      <UpsellCarousel
        showPrice={false}
        isPlusSizeSelected={isPlusSizeSelected}
        showReviewStars
        products={products}
        psrc="oos"
      />
    </CarouselWrapper>
  );
}

OOSCarousel.propTypes = {
  fplIds: PropTypes.array,
};

export default OOSCarousel;
